import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-461cc678"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "terms-wrapper px-6" }
const _hoisted_3 = { class: "agree" }
const _hoisted_4 = ["text"]
const _hoisted_5 = ["disabled"]

import { useRouter } from 'vue-router'
import { computed, ref } from 'vue'

import AccountWizard from '@/popup/components/shared/Wizard.vue'
import { t } from '@/popup/lib/i18n'
import { termsOfUse } from '@/popup/components/views/Onboard/TermsOfUse/termsOfUse'


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsOfUse',
  setup(__props) {

const router = useRouter()

const buttonDisabled = ref(true)
const shake = ref(false)

const onSubmit = () => {
  if (isButtonDisabled.value) {
    shake.value = true
    setTimeout(() => (shake.value = false), 1000)
  } else {
    router.push({ path: '/create-account', name: 'createNewPassword' })
  }
}

const isButtonDisabled = computed(() => {
  if (__IS_TEST__) {
    return false
  }
  return buttonDisabled.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AccountWizard, {
      title: _ctx.$t('terms_of_use.terms'),
      progress: 30
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('terms_of_use.agree')), 1 /* TEXT */),
      _createElementVNode("div", null, [
        _createElementVNode("lukso-terms", {
          "data-testid": "agree-terms-content",
          onOnBottomScroll: _cache[0] || (_cache[0] = ($event: any) => (buttonDisabled.value = false)),
          text: _unref(termsOfUse)
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4)
      ]),
      _createElementVNode("form", {
        class: "buttons mt-6",
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        _createElementVNode("lukso-button", {
          "data-testid": "disagree-button",
          variant: "text",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/welcome')))
        }, _toDisplayString(_ctx.$t('terms_of_use.disagree')), 1 /* TEXT */),
        _createElementVNode("div", {
          class: _normalizeClass(shake.value ? 'shake' : '')
        }, [
          _createElementVNode("lukso-button", {
            disabled: isButtonDisabled.value,
            "is-full-width": true,
            "data-testid": "agree-button",
            onClick: onSubmit,
            type: "submit"
          }, _toDisplayString(_ctx.$t('terms_of_use.agree_continue')), 9 /* TEXT, PROPS */, _hoisted_5)
        ], 2 /* CLASS */)
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}
}

})